import { IStyledProps } from '../../theme';
import styled from 'styled-components';
import { Heading } from '../Heading/Heading';
import { Button } from '../Button/Button';

interface IContainerProps {
  columnNumber?: number;
}

export const StyledSupportServicesContainer = styled.div<IContainerProps>`
  background: ${(props) =>  (props.columnNumber || 0) % 2 === 0 ? 'white' : props.theme.colors.defaultBackground};
  width: 100%;
  padding: 40px 30px;
`;

export const StyledSupportServicesHeaderContainer = styled(StyledSupportServicesContainer)`
  background-image: linear-gradient(40deg, black, black, #0a0a0a, #252525, #535050);
  color: white;
`;

export const StyledSupportServicesHeading = styled(Heading).attrs({ primary: true, level: 'h3' })`
  font-size: 42px;
  font-family: ${(props: IStyledProps) => props.theme.fonts.body};
  font-weight: 400;
  line-height: 114.99999999999999%;
  letter-spacing: 0px;
  vertical-align: middle;
  text-align: left;
  margin: 2.5rem 0;
  text-transform: unset;
`;

export const StyledSupportServicesIconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem 0;
`;

export const StyledSupportServicesSubHeading = styled(Heading).attrs({ primary: true, level: 'h4' })`
  text-align: left;
  font-size: 42px;
  padding-bottom: 30px;
  font-family: ${(props: IStyledProps) => props.theme.fonts.heading};
  font-weight: 400;
`;

export const StyledSupportServicesOrgName = styled(Heading).attrs({ primary: true, level: 'h5' })`
  text-align: left;
  font-family: Overpass;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0px;
  text-transform: uppercase;

`;


export const StyledSupportServicesDescription = styled.div`
  width: 100%;
  text-align: left;
  line-height: 140%;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 20px;
`;

export const StyledSupportServicesLink = styled(StyledSupportServicesOrgName)`
  text-decoration: underline;
  text-decoration-thickness: 2px;
  font-weight: 400;
  text-transform: lowercase;
`;

export const StyledSupportServicesButton = styled(Button)`
  width: 90%;
  margin: 1.5rem 5%;
`;

export const StyledSupportServicesNumber = styled(StyledSupportServicesOrgName)`
  font-weight: 400;
`;

export const StyledSupportServicesCloseIcon = styled.div`
  svg {
    width: 20px;
    height: 20px;
  }
  float: right;
`;

export const StyledSupportServicesOrgContainer = styled.div`
  margin: 1.5rem 0;
`;

export const StyledSupportServiceNavigationContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;